export default function Craftsmanship() {
  const features = [
    {
      icon: 'ri-hammer-line',
      title: 'Hand-Forged Quality',
      description: 'Every weapon is meticulously crafted by hand using traditional woodworking techniques passed down through generations. No mass production, no shortcuts—only dedication to the craft and attention to every detail that makes each piece unique and exceptional.'
    },
    {
      icon: 'ri-shield-line',
      title: 'Battle-Tested Strength',
      description: 'Built with high-quality materials selected for durability and performance. Each weapon undergoes rigorous testing to ensure it can withstand real-world use. We create tools that are not just beautiful to display, but functional and reliable when it matters most.'
    },
    {
      icon: 'ri-fire-line',
      title: 'Warrior Spirit',
      description: 'More than just weapons, these are symbols of discipline, preparedness, and the warrior mindset. Each piece embodies the values of strength, self-reliance, and respect for the craft. For those who take personal protection and craftsmanship seriously.'
    }
  ];

  return (
    <section id="craftsmanship" className="bg-[#0d1117] py-16 sm:py-24 lg:py-32 px-4 sm:px-8">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="mb-12 sm:mb-16 lg:mb-20">
          <div className="text-[10px] sm:text-xs uppercase tracking-wide text-[#718096] mb-3 sm:mb-4">WHY DARK WARRIOR</div>
          <h2 className="text-[48px] sm:text-[64px] lg:text-[76px] font-black text-[#F7F7F7] leading-none" style={{ lineHeight: '0.95' }}>
            FORGED IN
            <br />
            TRADITION
          </h2>
        </div>

        {/* Three Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#2d3748] rounded-2xl sm:rounded-3xl p-8 sm:p-10 lg:p-12 border-t-4 border-transparent hover:border-[#8B6914] transition-all duration-300 hover:transform hover:-translate-y-2 cursor-pointer group"
            >
              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center mb-6 sm:mb-8">
                <i className={`${feature.icon} text-[40px] sm:text-[48px] text-[#8B6914] group-hover:scale-110 transition-transform`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-bold text-[#F7F7F7] mb-4 sm:mb-5">{feature.title}</h3>

              {/* Description */}
              <p className="text-sm sm:text-base text-[#718096] leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
